<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.prestation',2) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="row">
                    <b-container>
                        <b-row>
                            <b-col col sm="12">
                                <section class="container" id="appointment-table">
                                    <div class="appointment-table-header my-2 mb-4">
                                        <b-button @click="handleOnAddClick" v-if="can">
                                            <i class="fa fa-plus edit-icon"></i>
                                            {{ $t('message.add') }}
                                        </b-button>

                                        <div class="d-inline-block ml-1 mr-5 width-270">
                                            <b-input-group
                                                    size="sm"
                                                    class="mb-3"
                                            >
                                                <b-form-input
                                                        type="text"
                                                        size="sm"
                                                        class="p-2 h-100"
                                                        :placeholder="$t('message.filter') + '...'"
                                                        v-model="filterCriteria"
                                                ></b-form-input>
                                                <b-input-group-append>
                                                    <b-button
                                                            size="sm"
                                                            text="Button"
                                                            variant="primary"
                                                            @click="handlerOnFilterButton"
                                                    >
                                                        Go
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>

                                            <div
                                                    v-if="paginationObject.numOfPages > 1"
                                                    class="pagination-wrapper d-inline-block"
                                            >
                                                <div class="pagination">
                                                    <a
                                                            href="#"
                                                            :class="'prev page-numbers ' + (
                                                        paginationObject.currentPageNumber === 1
                                                            ? 'pagination-disabled'
                                                            : ''
                                                        )"
                                                            @click="_handlePaginationClick('prev')"
                                                    >
                                                        <i aria-hidden="true" class="v-icon fas fa-chevron-left"></i>
                                                    </a>
                                                    <template v-for="(pageNumber, key) in paginationObject.listOfPageNumber()">
                                                        <template v-if="pageNumber === paginationObject.currentPageNumber">
                                                        <span
                                                                :key="key"
                                                                aria-current="page"
                                                                class="page-numbers current"
                                                        >
                                                            {{ pageNumber }}
                                                        </span>
                                                        </template>
                                                        <template v-else>
                                                            <a
                                                                    href="#"
                                                                    :key="key"
                                                                    class="page-numbers"
                                                                    @click="_handlePaginationClick(pageNumber)"
                                                            >
                                                                {{ pageNumber }}
                                                            </a>
                                                        </template>
                                                    </template>
                                                    <a
                                                            href="#"
                                                            class="next page-numbers"
                                                            :class="'next page-numbers ' + (
                                                        paginationObject.currentPageNumber === paginationObject.numOfPages
                                                            ? 'pagination-disabled'
                                                            : ''
                                                        )"
                                                            @click="_handlePaginationClick('next')"
                                                    >
                                                        <i aria-hidden="true" class="v-icon fas fa-chevron-right"></i>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row appointment-table-content">
                                        <div class="container-fluid">
                                            <template
                                                    v-if="paginationObject.display(paginationObject.currentPageNumber).length > 0"
                                            >
                                                <div
                                                    v-for="(prestation, key) in paginationObject.display(paginationObject.currentPageNumber)"
                                                    :key="key"
                                                    class="row appointment-item hovered"
                                                    @click="onPrestationClick(prestation.slug)"
                                                >
                                                    <div class="col-lg-4">
                                                        <span class="appointment-label">
                                                            {{ $t('message.name') }}
                                                        </span>
                                                        <h4 class="appointment-date">{{ prestation.name }}</h4>
                                                    </div>
                                                    <div class="col-lg-4">
                                                        <span class="appointment-label">
                                                            {{ $t('message.nomDeLaCategorie') }}
                                                        </span>
                                                        <h4
                                                            class="appointment-hour"
                                                        >
                                                            {{ prestation.category }}
                                                        </h4>
                                                    </div>
                                                    <div class="col-lg-4">
                                                        <span class="appointment-label">
                                                            {{ $t('message.price') }}
                                                        </span>
                                                        <h4
                                                            class="appointment-hour"
                                                        >
                                                            {{ _displayNumber(prestation.price) }}
                                                        </h4>
                                                    </div>
                                                </div>
                                            </template>

                                            <template v-else>
                                                <h4>{{ $t('message.noItemToDisplay') }}</h4>
                                            </template>

                                        </div>
                                    </div>
                                </section>
                            </b-col>
                        </b-row>
                    </b-container>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import _ from 'lodash';
	import { pagination, handlePaginationClick } from "../../helpers/paginations";
	import { displayNumber } from "../../helpers/general";

    export default {
        name: "List",
        computed: {
            ...mapGetters([
                "prestations",
                'hasAdminRole',
                'hasMedecinControleRole',
                'hasPatientRole',
                'hasPraticienRole',
                'hasSouscripteurRole',
                'hasGestionnaireRole',
                'isComptable',
                'hasAssistante'
            ]),

            can: function () {
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasMedecinControleRole || this.isComptable || this.hasAssistante;
            },

            prestationColumns: function () {
                return [
                    {
                        label: this.$i18n.tc('message.nomDeLaCategorie'),
                        field: 'categorie',
                    },

                    {
                        label: this.$i18n.tc('message.name'),
                        field: 'nom',
                    },
                    {
                        label: this.$i18n.tc('message.price'),
                        field: 'prix',
                    },
                ];
            },

            prestationRows:function(){
                let cArray = [];
                let self = this;
                _.forEach(self.prestations, function (prestation) {
                    cArray.push({
                        nom:prestation.nom,
                        prix:prestation.prix,
                        slug:prestation.slug,
                        categorie:_.isNull(prestation.categorie) ? self.$i18n.t('message.nonDefinie') : prestation.categorie.nom
                    })
                })
                return cArray;
            }
        },
        data(){
            return {
				filterCriteria: '',
				currentPrestationsDisplayed: [],
				paginationObject: {},
                paginationOptions: {
                    enabled: true,
                    mode: 'records',
                    perPageDropdown: [3, 6, 10]
                },
            }
        },

		watch: {
			prestations: function (newValue, oldValue) {
				const self = this;
				this.currentPrestationsDisplayed = newValue
					.map(prestation => ({
						slug: prestation.slug,
						name: prestation.nom,
						price: prestation.prix,
						category: _.isNull(prestation.categorie) ? self.$i18n.t('message.nonDefinie') : prestation.categorie.nom
					}));
			},

			currentPrestationsDisplayed: function (newValue, oldValue) {
				this.paginationObject = pagination(newValue);
			},

			filterCriteria: function (newValue, oldValue) {
				this.handleFilter(newValue);
			}
		},

        methods:{
			handleOnAddClick() {
                this.$router.push({ name: 'add-prestation' });
            },

			handlerOnFilterButton() {
				event.preventDefault();
				this.handleFilter(this.filterCriteria);
			},

			_handlePaginationClick(action) {
				this.paginationObject = handlePaginationClick(action, {...this.paginationObject});
			},

			handleFilter(value) {
				if (value) {
					const newCurrentPrestationsDisplayed = this.currentPrestationsDisplayed.filter(app => {
						let result = false;

						if (app.name) {
							result = result || app.name.toLowerCase().includes(value.toLowerCase());
						}

						if (app.price) {
							result = result || app.price.toLowerCase().includes(value.toLowerCase());
						}

						return result;
					});

					this.paginationObject = pagination(newCurrentPrestationsDisplayed);
				} else {
					this.paginationObject = pagination(this.currentPrestationsDisplayed);
				}
			},

			getPrestations() {
                let args = {
                };
                this.$store.dispatch("getPrestations", {args});
            },

            onPrestationClick(slug){
                this.$router.push({ name: 'prestation', params: { prestation: slug } });
            },

            _displayNumber: displayNumber,
        },

        mounted() {
            this.getPrestations();
        }
    }
</script>

<style scoped>

</style>
